import { registerLookup } from "@redriver/cinnamon";
import { getGroups } from "./actions";

export const groupsLookup = registerLookup("groupsLookup", getGroups, {
  transform: (data) => data.map((x) => ({ value: x.id, text: x.name })),
  cache: false,
});
